import { memo, useState, useRef, useEffect } from 'react';
import { Button, ClickAwayListener, Grow, Paper, MenuItem, Popper, MenuList, Stack, ListItemIcon, ListItemText, IconButton } from '@mui/material';
import { NotificationsRounded, SmsRounded, WhatsApp } from '@mui/icons-material';
import useConfirm from 'core/hooks/useConfirm';
import { logger } from 'core/utils/logger';
import { sendRentDueReminder } from 'services/payments';
import { useSnackbar } from 'notistack';

export default memo(function RentDueReminders({pageRef, enableMultiplePayments, paymentId, isInmatePaymentReminder = false}) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const confirm = useConfirm();
  const { enqueueSnackbar } = useSnackbar();

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event?.target)) {
      return;
    }
    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = useRef(open);
  
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  function onSendWhatsAppReminderBtnClick(e) {
    confirm({title: isInmatePaymentReminder ? 'Do you wish to send WhatsApp reminder to tenant?' : 'Do you wish to send WhatsApp reminder to Tenants?'})
    .then(() => sendReminder('whatsApp'))
    .catch(() => handleClose(e))
  }

  function onSendSMSReminderBtnClick(e) {
    confirm({title: isInmatePaymentReminder ? 'Do you wish to send SMS reminder to tenant?' : 'Do you wish to send SMS reminder to tenants?'})
    .then(() => sendReminder('sms'))
    .catch(() => handleClose(e))
  }

  function sendReminder(type) {
    logger.debug('[PaymentsPage]:{getPaymentsList} fetching data');
    const params = isInmatePaymentReminder ? {paymentId} : {};
    sendRentDueReminder(type, params, {pageRef}).then(({response, error}) => {
      handleClose();

      if(error?.message === 'canceled') return;
      // Return if any error
      if(error)return enqueueSnackbar(error?.message, {variant: 'error'});
      enqueueSnackbar('Reminder has been sent', {variant: 'success'});
    });
  }

  return (
    <Stack direction="row" spacing={2}>
      <div>
        {isInmatePaymentReminder ? 
        <IconButton 
          color='info' 
          onClick={handleToggle}  
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? 'composition-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
        >
          <NotificationsRounded sx={{fontSize: '20px'}} />
        </IconButton> 
        : <Button
          ref={anchorRef}
          color='info' 
          id="composition-button"
          aria-controls={open ? 'composition-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          // endIcon={<ExpandMoreRounded />}
          startIcon={<NotificationsRounded />}
        >
          Reminders
        </Button>
        }
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="top-start"
          transition
          disablePortal
          sx={{zIndex: 1}}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === 'bottom-start' ? 'left top' : 'right top',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                  >
                    <MenuItem onClick={onSendSMSReminderBtnClick}>
                      <ListItemIcon>
                        <SmsRounded fontSize="small" color="info" />
                      </ListItemIcon>
                      <ListItemText>{isInmatePaymentReminder ? 'SMS' : 'Send Payment Due SMS Reminder'}</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={onSendWhatsAppReminderBtnClick}>
                      <ListItemIcon>
                        <WhatsApp fontSize="small" color="info" />
                      </ListItemIcon>
                      <ListItemText>{isInmatePaymentReminder ? 'WhatsApp' : 'Send Payment Due WhatsApp Reminder'}</ListItemText>
                    </MenuItem>
                    {/* <MenuItem onClick={() => {handleClose();enableMultiplePayments();}}>
                      <ListItemIcon>
                        <ChecklistRounded fontSize="small" color="info" />
                      </ListItemIcon>
                      <ListItemText>Collect Multiple Payments</ListItemText>
                    </MenuItem> */}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </Stack>
  );
});